import type { ParseKeys, TOptions } from 'i18next';
import { i18n } from 'next-i18next';
import type { JSXElementConstructor, ReactElement } from 'react';

export const getTranslatedText = (key: ParseKeys<'common'>, options?: TOptions) => () =>
  i18n?.t(key, options) ?? key;

type TranslatedComponents = {
  [index: string]: ReactElement<unknown, string | JSXElementConstructor<unknown>> | undefined;
  ko: ReactElement<unknown, string | JSXElementConstructor<unknown>>;
  en?: ReactElement<unknown, string | JSXElementConstructor<unknown>>;
};

export const getTranslatedComponent = (components: TranslatedComponents) => {
  const currentLanguage = i18n?.language ?? 'ko';

  return components[currentLanguage] ?? components.ko;
};
